import { render, staticRenderFns } from "./offsetDetails.vue?vue&type=template&id=e5e85262&scoped=true&"
import script from "./offsetDetails.vue?vue&type=script&lang=js&"
export * from "./offsetDetails.vue?vue&type=script&lang=js&"
import style0 from "./offsetDetails.vue?vue&type=style&index=0&id=e5e85262&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e85262",
  null
  
)

component.options.__file = "offsetDetails.vue"
export default component.exports